"use client"

import { defineSlotRecipe } from "@chakra-ui/react"
import { selectAnatomy } from "@chakra-ui/react/anatomy"

const select = defineSlotRecipe({
  className: "hydrologiq-select",
  slots: selectAnatomy.keys(),

  variants: {
    variant: {
      hydrologiq: {
        root: {
          color: "primary",
        },

        control: {
          gap: "2px",
          borderRadius: "{radii.card}",
          borderWidth: "1px",
          borderColor: "divider",
          _hover: {
            cursor: "pointer",
          },
        },

        indicator: {
          paddingRight: "3px",
        },

        item: {
          margin: "0px 6px",
          fontWeight: "normal !important",
          _hover: {
            color: "white",
            bg: "#0bc5ea",
            cursor: "pointer",
            opacity: "0.8",
          },
          _selected: {
            color: "white",
            bg: "#0bc5ea",
          },
          _disabled: {
            opacity: "0.5",
            cursor: "not-allowed",
          },
        },
      },
    },
  },
})

export default select
